import React from 'react';
import NavSearchBar from '../Header/NavSearchBar';

export default function SubscribeCTA() {
  return (
    <section className="xcta-search-section background-img-2"
      style={{ backgroundImage: "url('/img/footer-bg.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'center top', backgroundSize: 'cover' }}>
      <img src="/img/footer-top-shape.svg" alt="" className="xcta-wave" aria-hidden="true" />
      <div className="container">
        <div className="xcta-search-inner">
          <h2 className="xcta-search-headline">Where to Next?</h2>
          <p className="xcta-search-sub">Pick a region, set your pace, and we'll build your adventure.</p>
          <div className="xcta-desktop-search">
            <NavSearchBar />
          </div>
          <div className="xcta-mobile-search">
            <NavSearchBar mobile />
          </div>
        </div>
      </div>
    </section>
  );
}
